import { useCallback, useSyncExternalStore } from 'react';
import { ParticipantEvent, type Participant } from 'livekit-client';

/**
 * Lee un atributo de un participante remoto y se actualiza cuando cambia.
 *
 * Reemplaza a `useParticipantAttribute` de @livekit/components-react, que LANZA
 * («No participant provided…») si no recibe participante y no está dentro de un
 * ParticipantContext. En la videollamada el paciente todavía no está en la sala
 * cuando el médico entra —o acaba de salir, o está reconectando—, así que el
 * participante es `undefined` justo en esos momentos y el error tumbaba la
 * página completa del médico (23-oct-2026, producción). Sin participante, aquí
 * simplemente no hay valor.
 */
export function useAtributoParticipante(participant: Participant | undefined, clave: string): string | undefined {
  const suscribir = useCallback((avisar: () => void) => {
    if (!participant) return () => {};
    participant.on(ParticipantEvent.AttributesChanged, avisar);
    return () => {
      participant.off(ParticipantEvent.AttributesChanged, avisar);
    };
  }, [participant]);
  return useSyncExternalStore(suscribir, () => participant?.attributes?.[clave]);
}
